<template>
  <div class="search-box">
    <van-form @submit="onSubmit">
      <van-field v-model="name" name="用户名" size="large" class="input-bg" placeholder="请输入姓名"
        :rules="[{ required: true }]" />
      <van-field v-model="number" name="密码" class="input-bg" size="large" placeholder="请输入身份证号码"
        :rules="[{ required: true }]" />
      <div>
        <van-button type="danger" block icon="search">查询</van-button>
      </div>
    </van-form>

    <div class="result-box">
      <div class="matchs" v-for="(item, index) in searchResult" :key="index">
        <a class="result-match"
          :href="`/personalSignUp?userId=${item.userId}&matchId=${item.matchId}&projectId=${item.projectId}`">
          <span class="name">{{ item.matchName }}</span>
          <!-- <span class="go">查看详情</span> -->
        </a>
        <table class="result-list">
          <tr class="result-item">
            <td class="td-title">姓名：</td>
            <td class="td-value">{{ item.name }}</td>
          </tr>
          <tr>
            <td class="td-title">性别：</td>
            <td class="td-value">{{ item.sex === 1 ? "男" : "女" }}</td>
          </tr>
          <tr>
            <td class="td-title">参赛项目：</td>
            <td class="td-value">{{ item.projectName }}</td>
          </tr>
          <tr>
            <td class="td-title">衣服尺码：</td>
            <td class="td-value">{{ item.dressSize }}</td>
          </tr>
          <tr>
            <td class="td-title">参赛费用：</td>
            <td class="td-value">{{ item.price }}</td>
          </tr>
          <tr>
            <td class="td-title" v-if="item.projectNumber">参赛号码：</td>
            <td class="td-value">{{ item.projectNumber }}</td>
          </tr>
        </table>
      </div>

      <div class="result-end" v-if="searchResult.length > 0">
        -------------- . 疯马体育 . -------------
      </div>
    </div>
  </div>
</template>

<script>
  import { fetchHttp } from "@/util/fn.js";

  import { Button, Toast } from "vant";

  export default {
    name: "ApplySearch",
    components: {
      [Button.name]: Button,
    },
    props: {
      submitUrl: String,
      defaultName: String,
      defaultNumber: String,
      domain: Number,
    },
    data() {
      return {
        title: "成绩查询",
        searchResult: [],
        name: this.defaultName || "", //伍靖
        number: this.defaultNumber || "", //360430199409050330
      };
    },
    computed: {},
    mounted() {
      if (this.defaultName && this.defaultNumber) {
        this.onSubmit();
      }
    },
    methods: {
      onSubmit() {
        if (this.submitUrl) {
          this.$router.push({
            path: this.submitUrl,
            query: {
              name: this.name,
              number: this.number,
            },
          });
          return;
        }
        if (this.name && this.number) {
          fetchHttp(
            "marathon/signUp/othersInformation",
            { name: this.name, number: this.number, domain: this.domain },
            "GET"
          ).then((res) => {
            if (res && res.code === 0) {
              if (res.data && res.data.length > 0) {
                this.searchResult = res.data;
              } else {
                this.searchResult = [];
                // showNotification('error', '提示', '没有搜索到相关报名信息');
                Toast.fail("没有搜索到相关报名信息");
              }
            }
          });
        } else {
          //   showNotification('error', '提示', '请输入姓名/身份证号码来查询！');
          Toast.fail("没有搜索到相关报名信息");
        }
      },
    },
  };
</script>
<style scope lang="less">
  .search-box {
    padding: 0 10px;
  }

  .input-bg {
    background-color: #eee;
    margin: 10px 0;
  }

  ::-webkit-input-placeholder {
    color: #999 !important;
  }

  .matchs {
    margin-top: 15px;
  }

  .result-box {
    padding-bottom: 20px;
  }

  .result-match {
    padding: 5px 10px;
    font-size: 14px;
    color: #ee0a24;
    overflow: hidden;
    display: flex;

    .name {
      flex: 1;
    }

    .go {
      width: 50px;
      text-align: right;

      font-size: 12px;
      color: #ee0a24;
      vertical-align: bottom;
    }
  }

  .result-list {
    width: 100%;
    font-size: 12px;
    color: #444;
    border-top: 1px solid #efefef;

    // line-height: 28px;
    td {
      height: 28px;
    }

    .td-title {
      width: 90px;
      text-align: right;
      border-bottom: 1px solid #efefef;
    }

    .td-value {
      // width:70%;
      text-align: left;
      border-bottom: 1px solid #efefef;
    }
  }

  .result-end {
    color: #bbb;
    text-align: center;
    padding: 15px 0;
    font-size: 12px;
  }
</style>